import '!style-loader!css-loader!sass-loader!./fonts/Gotham/fonts.scss'
import '!style-loader!css-loader!sass-loader!./fonts/PanIcons/fonts.scss'
import '!style-loader!css-loader!sass-loader!./fonts/Pantamera/fonts.scss'
import React from 'react'
import { Route, Switch, useLocation } from 'react-router-dom'
import 'react-tabs/style/react-tabs.css'
import './App.scss'
import About from './components/About/About'
import Breadcrumbs from './components/Breadcrumbs/Breadcrumbs'
import Icon from './components/Icon/Icon'
import ReportsPage from './components/ReportsPage/ReportsPage'
import StartPage from './components/StartPage/StartPage'

import logoMixed from './images/returpack_logo.svg'
import heroWaveBottom from './images/wave-bottom.svg'

export interface Page {
  reportName: string
  route: string
  menuLabel: string
  description: string
  cardIcon: string
}

export const pages: Page[] = [
  {
    reportName: 'pantamera_arsstatistik_PBI',
    route: 'arsstatistik',
    menuLabel: 'Årsstatistik',
    description:
      'Här hittar du årsstatistiken för senaste helår, på riks-, läns- och kommunnivå. Statistiken visas i totalt antal pantade förpackningar samt i antal pantade',
    cardIcon: 'bottle-can'
  },
  {
    reportName: 'pantamera_atervinningsgrad_PBI',
    route: 'pantningsgrad',
    menuLabel: 'Pantningsgrad',
    description:
      'Här hittar du pantningsgraden, dels för senaste helår, dels några år bakåt för jämförelse.',
    cardIcon: 'recycle-symbol'
  },
  {
    reportName: '',
    route: 'about',
    menuLabel: 'Om Statistiken',
    description:
      'Varje år sammanställer vi statistik över hur mycket som pantas i Sverige och därmed kan återvinnas till nya burkar och flaskor.',
    cardIcon: 'reporting'
  }
]

export function resolveReport(proposedName: string): string {
  if (
    pages.filter(function (r) {
      return r.reportName == proposedName
    })[0]
  ) {
    return proposedName
  }

  return pages[0].reportName //fallback
}

export const selectReportNameFromRoute = (routeName: string): string => {
  const sanitizedRouteName = routeName.replace('/', '')

  const section = pages.find((sec: Page) => sec.route === sanitizedRouteName)
  if (section) {
    return section.reportName
  } else {
    return ''
  }
}

const selectMenuLabelFromRoute = (route: string): string => {
  const routeWithoutSlash = route.replace('/', '')

  const section = pages.find((sec: Page) => sec.route === routeWithoutSlash)

  if (section) {
    return section.menuLabel
  } else {
    return ''
  }
}

const appClassByRoute = (): string => {
  const location = useLocation()
  console.log(location)
  if (location.pathname === '/' || location.pathname === '/about') {
    return 'app'
  } else if (location.pathname === '/arsstatistik') {
    return 'subpage arsstatistik'
  } else {
    return 'subpage'
  }
  return location.pathname
}

const App: React.FC = () => {
  const pathName = appClassByRoute()

  return (
    <>
      <div className="header">
        <a
          className="logo-link"
          href="https://pantamera.nu/"
          target="_blank"
          rel="noreferrer"
        >
          <img className="logo" src={logoMixed} alt="returpack - pantamera" />
        </a>
        <a href="/" className="title">
          Pantamera statistik
        </a>
        <div className="dummy"></div>
      </div>
      <div className="header-line"></div>
      <div className={`scrollable-content ${pathName}`}>
        <div className="hero-container">
          <div className="hero-bg-image-container">
            <div className="hero-scroll-container">
              <div className="hero-bg-image"></div> {/* img src in scss */}
              <div className="wave-image">
                <img src={heroWaveBottom} alt="" />
              </div>
            </div>
          </div>
        </div>

        <div className="content">
          <div className="container">
            <Breadcrumbs selectMenuLabel={selectMenuLabelFromRoute} />
            <Switch>
              <Route path="/pantningsgrad" exact component={ReportsPage} />
              <Route path="/arsstatistik" exact component={ReportsPage} />
              <Route path="/about" exact component={About} />
              <Route path="/" component={StartPage} />
            </Switch>
          </div>
        </div>
        <div className="footer">
          <div className="footer-content">
            <div className="dummy"></div>
            <div className="footer-social-media">
              <a
                className="iconbubble"
                href="https://www.facebook.com/pantamera"
                target="_blank"
                rel="noreferrer"
              >
                <Icon iconName="facebook" color="#ffffff" size={36} />
              </a>
              <a
                className="iconbubble"
                href="https://www.youtube.com/user/pantameranu"
                target="_blank"
                rel="noreferrer"
              >
                <Icon iconName="youtube" color="#ffffff" size={36} />
              </a>
              <a
                className="iconbubble"
                href="https://www.instagram.com/pantameranu/"
                target="_blank"
                rel="noreferrer"
              >
                <Icon iconName="instagram" color="#ffffff" size={36} />
              </a>
            </div>
            <div className="footer-links">
              <a
                href="https://pantamera.nu/sv/integritetspolicy/"
                target="_blank"
                rel="noreferrer"
              >
                Integritetspolicy
              </a>
              <div className="footer-link-separator">|</div>
              <a
                href="https://pantamera.nu/sv/cookies/"
                target="_blank"
                rel="noreferrer"
              >
                Cookies
              </a>
              <div className="footer-link-separator">|</div>
              <a
                href="https://pantamera.nu/sv/om-oss/kontakta-oss/"
                target="_blank"
                rel="noreferrer"
              >
                Kontakta oss
              </a>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

export default App
